import { intl } from "dmsbasereact";

export const StockAdjustmentTypeEnum = {
    LOSS: 0,
    SURPLUS: 1,
    EXPIRED: 2,
    DAMAGED: 3,
    THEFT: 4,
    OTHER: 5,
};

export const StockAdjustmentType = {
    /**
     * @param {number} code
     * @returns {string} Translated label
     */
    getText: (code) => {
        switch (code) {
            case StockAdjustmentTypeEnum.LOSS:
                return intl.get("StockAdjustmentType.LOSS").d("Perda/Falta");
            case StockAdjustmentTypeEnum.SURPLUS:
                return intl.get("StockAdjustmentType.SURPLUS").d("Excesso");
            case StockAdjustmentTypeEnum.EXPIRED:
                return intl.get("StockAdjustmentType.EXPIRED").d("Expirado");
            case StockAdjustmentTypeEnum.DAMAGED:
                return intl.get("StockAdjustmentType.DAMAGED").d("Danificado");
            case StockAdjustmentTypeEnum.THEFT:
                return intl.get("StockAdjustmentType.THEFT").d("Roubo");
            case StockAdjustmentTypeEnum.OTHER:
                return intl.get("StockAdjustmentType.OTHER").d("Outro");
            default:
                return intl.get("Unknown").d("Desconhecido");
        }
    },

    /**
     * @param {number} code
     * @returns {string} MUI color name
     */
    getColor: (code) => {
        switch (code) {
            case StockAdjustmentTypeEnum.LOSS:
                return "error";
            case StockAdjustmentTypeEnum.SURPLUS:
                return "success";
            case StockAdjustmentTypeEnum.EXPIRED:
                return "warning";
            case StockAdjustmentTypeEnum.DAMAGED:
                return "error";
            case StockAdjustmentTypeEnum.THEFT:
                return "error";
            case StockAdjustmentTypeEnum.OTHER:
                return "default";
            default:
                return "default";
        }
    }
};

/**
 * @returns {Array<{value: number, label: string}>}
 */
export const getStockAdjustmentTypeOptions = () => [
    { value: StockAdjustmentTypeEnum.LOSS, label: StockAdjustmentType.getText(StockAdjustmentTypeEnum.LOSS) },
    { value: StockAdjustmentTypeEnum.SURPLUS, label: StockAdjustmentType.getText(StockAdjustmentTypeEnum.SURPLUS) },
    { value: StockAdjustmentTypeEnum.EXPIRED, label: StockAdjustmentType.getText(StockAdjustmentTypeEnum.EXPIRED) },
    { value: StockAdjustmentTypeEnum.DAMAGED, label: StockAdjustmentType.getText(StockAdjustmentTypeEnum.DAMAGED) },
    { value: StockAdjustmentTypeEnum.THEFT, label: StockAdjustmentType.getText(StockAdjustmentTypeEnum.THEFT) },
    { value: StockAdjustmentTypeEnum.OTHER, label: StockAdjustmentType.getText(StockAdjustmentTypeEnum.OTHER) },
];
